import get from 'lodash/get'
import {
  GET_DASHBOARD_DATA,
  GET_IPM_DASHBOARD_DATA
} from './../constants/actionTypes'

const initStore = {}

const dashboard = (store = initStore, action = {}) => {
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      return get(action, 'data.data.embarkationAdminDashboard', {})
    default:
      return store
  }
}

const calendarData = (store = [], action = {}) => {
  switch (action.type) {
    case GET_IPM_DASHBOARD_DATA:
    return get(action, 'data.data.inPortManningDashboard', [])
    default:
      return store
  }
}

export { dashboard, calendarData }
